import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  WheelIcon,
  ShieldNoBorder,
  covidAmens,
  PickupIcon,
  DropoffIcon,
  GsbLogoBold,
  Clock,
  SeatErrorIcon,
  TripIcon,
  TickMarkIcon,
  FareDownArrow,
  FareUpArrow,
} from "../common/icons/svg";
import { updateCheckoutDet, updateLevyAndConcession, updateLoader, updateSeatChartErrorMsg, updateOrderToken, updateShowpassenger } from "../../actions/search-actions";
import store from "../../store";
import { apiUrl, color } from "../common/constants";
import FemaleSeatAlert from "../common/femaleSeatAlert";
import {
  getRevDate,
  get24HoursTime,
  fetchGet,
  fetchPost,
} from "../../common/common";
import { renderImg } from "../common/icons/img";
import Passenger from "../checkout/passenger";
import { customSort, getIPAddress, convertToTime } from "../common/helper";

import { formatTimeWithAMPM } from "../../common/common";

import {
  t, SELECT_SEAT, SELECT_PADP, SELECT_BOARDING_POINT, SELECT_DROPPING_POINT, SELECTED, BOOKED, AVAILABLE, FEMALE, GRAND_TOTAL, SHOW_DETAILS, HIDE_DETAILS, TOTAL_FARE_DETAILS, PROVIDE_PASSENGER_DETAILS, CLOSE_CUSTOMER_DETAILS, SELECT_PDTC,
  SELECT, SEATS, BOARDING, DROPPING_POINT, UPPER, LOWER, SEATER, SLEEPER, BERTH
} from "../../translations/SeatChart";


class Seatchart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoad: true,
      seatchart: [],
      stchrt: [],
      error: false,
      fares: [],
      selPick: "",
      selDrop: "",
      selSeat: [],
      selSeatFare: [],
      seatFare: 0,
      disSeatFare: 0,
      chargePer: 0,
      chargeRs: 0,
      showPoint: "",
      countLower: 0,
      countUpper: 0,
      HasSeater: 0,
      HasSleeper: 0,
      extraFare1: 0,
      extraFare2: 0,
      totalSeat: 0,
      Covid19Config: false,
      seaterror: false,
      alerterror: "",
      pickuplistnew: [],
      dropofflistnew: [],
      showlinkfromcity: false,
      showlinktocity: false,
      linkfare1: 0,
      linkfare2: 0,
      picklinkTime: "",
      picklinkUpID: "",
      picklinkUpName: "",
      picklinkUpAddress: "",
      picklinkUpLandmark: "",
      picklinkUpPhone: "",
      droplinktime: "",
      picklinkcity: "",
      droplinkcity: "",
      droplinkUpID: "",
      ismantispg: false,
      logintoken: "",
      showStationInfromcity: false,
      showStationIntocity: false,
      pickStationName: "",
      pickStationTime: "",
      pickStationId: "",
      pickStationAddress: "",
      pickStationLandmark: "",
      pickStationPhone: "",
      dropStationName: "",
      dropStationTime: "",
      dropStationId: "",
      showFemalePopup: false,
      selseatVal: {},
      totalOnwardSeats: 0,
      returnChartSeatRestrictionFlag: false,
      openfareModal: false,
      gst: 0,
      baseFare: 0,
      levyDetails: {},
      levyNameArray: [],
      levyArray: [],
      levyTotal: 0,
      lvcndata: {},
      showPassenger: [],
      postData: {},
      groupDiscount: 0,
      orderData: {},
      onConAmt: 0,
      returnTripDiscPer: 10,
      pickCharge: 0,
      dropCharge: 0,
      // pickSelectedIndex: -1,
      // dropSelectedIndex: -1,
      // currentItemIndex: -1,
      currentpickItemIndex: -1,
      currentdropItemIndex: -1,
      pickupData: [],
      showAccoType: false,
      selAccoType: '',

      noOfPaxData: [],
      showNoOfPax: false,
      selNoOfPax: 0,

      busIdFarePerSeat: 0,
      seatWiseFare: 0,
      seatWiseSrFare: 0,
      totSeatFare: 0,

      showLoader: false,
      ip_address: '',

    };
    this.pickupDropdownRef = React.createRef();
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {

    store.dispatch(updateCheckoutDet({}))

    const that = this;

    let url = window.url + apiUrl.getSeatLayoutData + "?BusID=" + this.props.seat.BusID + "&Date=" + this.props.search.searchParams.jDate;
    //console.log(url);

    store.dispatch(updateLoader(false));

    fetchGet(url)
      .then(function (data) {

        const seatLayoutRes = JSON.parse(data);

        //console.log(data);

        if (seatLayoutRes?.Success) {

          const stchrt = seatLayoutRes?.data || [];
          that.setState({ stchrt, seatchart: stchrt });

          that.parseSeats();

        } else {
          that.setState({
            error: seatLayoutRes.ErrorMessage,
          });
          store.dispatch(updateSeatChartErrorMsg(that.props.seat.TripRouteID, seatLayoutRes.ErrorMessage));
        }
      })
      .catch(function (error) {
        console.log(error);
      });


    //for get pickup list data
    this.getPickupId(this.props.seat.BusID, this.props.search.searchParams.jDate);

    this.setState({ busIdFarePerSeat: this.props.seat.FarePerSeat });

    //for get fare
    this.getFare();

    //for get sr fare
    this.getSeniorFare();


    getIPAddress()
      .then((ip) => {
        this.setState({ ip_address: ip });
      })
      .catch((error) => {
        // Handle error
        console.error("Error:", error);
      });

    /* if (this.props.seoChartactive) {

      let curr;

      if (window.msurl == "shrinath.biz") {
        curr = document.getElementsByClassName("srch-card-sta active");
      } else {
        curr = document.getElementsByClassName("srch-card active");
      }

      const el = curr[curr.length - 1].getBoundingClientRect();
      window.scrollTo(0, el.top);
    } */

    /*  window.addEventListener("click", (e) => {
       if (
         window.location.pathname.indexOf("checkout") === -1 &&
         !(
           e.target.className.includes("point-inp") ||
           (e.target.parentNode &&
             e.target.parentNode.className.includes("point-inp")) ||
           (e.target.parentNode &&
             e.target.parentNode.parentNode &&
             e.target.parentNode.parentNode.className.includes("point-inp")) ||
           (e.target.parentNode &&
             e.target.parentNode.parentNode &&
             e.target.parentNode.parentNode.parentNode &&
             e.target.parentNode.parentNode.parentNode.className.includes(
               "point-inp"
             ))
         )
       ) {
         // this.setState({ showPoint: "" });
       }
     }); */

    /*     document.addEventListener('click', this.handleClickOutside);
    
        const pickdet =
          this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId] &&
          this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId].pickups;
    
        const dropdet =
          this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId] &&
          this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId]
            .dropPoints;
        const urlParams = new URLSearchParams(window.location.search);
        const linkfromCityId = urlParams.get("linkfromCity");
        const linktoCityId = urlParams.get("linktoCity");
        // const stationInFromCityId = urlParams.get("stationInFromCity");
        // const stationInToCityId = urlParams.get("stationInToCity");
        const stationInFromCityKey = urlParams.get("stationInFromCity");
        const stationInToCityKey = urlParams.get("stationInToCity");
        const stationInFromCity = stationInFromCityKey && stationInFromCityKey.split("|")[1].split(",");
        const stationInToCity = stationInToCityKey && stationInToCityKey.split("|")[1].split(",");
        // const stationInFromCity = stationInFromCityKey && stationInFromCityKey.split("|")[0].replace(/[^a-zA-Z]/g, " ");
        // const stationInToCity = stationInToCityKey && stationInToCityKey.split("|")[0].replace(/[^a-zA-Z]/g, " ");
        var showfromlink = false;
        var showtolink = false;
        var showStationFrom = false;
        var showStationTo = false;
        var pickuplistnew = [];
        var dropofflistnew = [];
        if (linkfromCityId) {
          if (pickdet !== undefined) {
            var key;
            for (key in pickdet) {
              if (pickdet[key].PickupLinkCityId === parseInt(linkfromCityId)) {
                pickuplistnew.push(pickdet[key]);
                showfromlink = true;
              }
            }
          }
          this.setState({ showlinkfromcity: showfromlink, pickuplistnew });
        } */

    /*  if (linktoCityId) {
       if (dropdet !== undefined) {
         var key;
         for (key in dropdet) {
           if (dropdet[key].DropLinkCityID === parseInt(linktoCityId)) {
             dropofflistnew.push(dropdet[key]);
             showtolink = true;
           }
         }
       }
       this.setState({ showlinktocity: showtolink, dropofflistnew });
     } */

    // filter through pickid

    /*  if (stationInFromCity && stationInFromCity.length > 0) {
       if (pickdet !== undefined) {
         var key;
         for (key in pickdet) {
           if (stationInFromCity.includes(String(pickdet[key].PickupID))) {
             // pickuplistnew.push(...pickdet);
             showStationFrom = true;
             this.setState({ pickStationName: pickdet[key].PickupName, pickStationTime: pickdet[key].PickupTime, pickStationId: pickdet[key].PickupID, pickStationAddress: pickdet[key].Address, pickStationLandmark: pickdet[key].Landmark, pickStationPhone: pickdet[key].ContactNumbers })
           }
         }
       }
       this.setState({ showStationInfromcity: showStationFrom, pickuplistnew });
     } */

    // filter through dropId

    /*  if (stationInToCity && stationInToCity.length > 0) {
       if (dropdet !== undefined) {
         var key;
         for (key in dropdet) {
           if (stationInToCity.includes(String(dropdet[key].DropoffID))) {
             // dropofflistnew.push(...dropdet);
             showStationTo = true;
             this.setState({ dropStationName: dropdet[key].DropoffName, dropStationTime: dropdet[key].DropoffTime, dropStationId: dropdet[key].DropoffID })
           }
         }
       }
       this.setState({ showStationIntocity: showStationTo, dropofflistnew });
     } */

    /* if (pickuplistnew.length > 0) {
      let linkfare1 = 0;
      if (pickuplistnew[0].PickupChargeRs > 0) {
        linkfare1 = pickuplistnew[0].PickupChargeRs;
      }
      if (
        pickuplistnew[0].PickupChargePer &&
        parseFloat(pickuplistnew[0].PickupChargePer) > 0
      ) {
        linkfare1 = Math.ceil(
          (parseFloat(this.state.seatFare) *
            parseFloat(pickuplistnew[0].PickupChargePer)) /
          100
        );
      }
      
      this.setState({
        linkfare1: linkfare1,
      });
    } */

    /* if (dropofflistnew.length > 0) {
      let linkfare2 = 0;
      if (dropofflistnew[0].DropoffChargeRs > 0) {
        linkfare2 = dropofflistnew[0].DropoffChargeRs;
      }
      if (
        dropofflistnew[0].DropoffChargePer &&
        parseFloat(dropofflistnew[0].DropoffChargePer) > 0
      ) {
        linkfare2 = Math.ceil(
          (parseFloat(this.state.seatFare) *
            parseFloat(dropofflistnew[0].DropoffChargePer)) /
          100
        );
      }
    
      this.setState({
        // linkfare2: linkfare2,
        // droplinktime,
        // droplinkcity,
        // droplinkUpID,
        // dropStationName,
        // dropStationTime,
        // dropStationId
      });
    } */

    /*  if (window.customerProfile && window.customerProfile.MobileNumber) {
       const tokenurl =
         window.url +
         apiUrl.getlogintoken +
         "?mobile=" +
         window.customerProfile.MobileNumber;
       fetchGet(tokenurl)
         .then(function (data) {
           if (data.token) {
             that.setState({ logintoken: data.token });
           }
         })
         .catch(function (error) {
           console.log(error);
         });
     } */
    /* const totalOnwardSeats = JSON.parse(sessionStorage.getItem("totalOnwardSeats"));
    const returnChartSeatRestrictionFlag = this.props.search.searchParams.token && !this.props.search.searchParams.linkfromstoptocity && this.props.search.stChrtStatus[this.props.seat.RouteScheduleId] ? true : false;

    if (totalOnwardSeats && returnChartSeatRestrictionFlag) {
      this.setState({ totalOnwardSeats: totalOnwardSeats, returnChartSeatRestrictionFlag: returnChartSeatRestrictionFlag })
    }

    this.getLeavyAndConcession(this.props.seat.RouteScheduleId, this.props.search.searchParams.token) */
  }

  handleClickOutside = (event) => {
    // Select the dropdown element.
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showPoint: "" }); // Close the dropdown
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.seatFare !== this.state.seatFare || prevState.pickCharge !== this.state.pickCharge || prevState.dropCharge !== this.state.dropCharge) {
      if (this.state.lvcndata && Object.keys(this.state.lvcndata).length > 0) {
        let onwardLevyConcData = this.state.lvcndata;
        const selSeats = this.state.seatchart.Seats;
        let levyAmt = 0;
        // let groupDiscount = 0;
        selSeats.forEach((el) => {
          if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
            this.updateOnwardSeatWiseGstNDiscount(el, onwardLevyConcData);
            let levy = el.l || [];
            if (levy.length) {
              levy.forEach(el => {
                levyAmt += el.a;
              })
            }
            // groupDiscount += el.GroupDiscount;
          }
        })
        this.setState({ levyTotal: levyAmt })
      }
      this.calculateGroupDiscount();
    }
  }

  componentWillUnmount() {
    // Remove the event listener when the component is unmounted to avoid memory leaks.
    document.removeEventListener('click', this.handleClickOutside);
  }


  /*  calculateGroupDiscount = () => {
     //console.log("hello");
     const selSeat = this.state.selSeat;
     const selSeats = this.state.seatchart.Seats;
     const levyConcData = this.state.lvcndata;
     const pickCharge = this.state.pickCharge;
     const dropCharge = this.state.dropCharge;
     const totalPickdropCharge = pickCharge + dropCharge;
     let discountAmt = 0;
     let groupDiscount = 0;
     if (this.props.search.searchParams.token && selSeat.length < 4) {
       selSeats.forEach((el) => {
         if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
           discountAmt = Math.floor(((el.BaseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100);
           groupDiscount += discountAmt;
         }
       })
 
     } else {
       if (
         levyConcData && Object.keys(levyConcData).length > 0 &&
         levyConcData.GroupDis && Object.keys(levyConcData.GroupDis).length > 0 &&
         selSeat.length >= levyConcData.GroupDis.MinSeat
       ) {
         //console.log("discount applicable");
         selSeats.forEach((el) => {
           //console.log("el", el);
           if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
             if (this.props.search.searchParams.token) {
               if (levyConcData.GroupDis.ReturnPtc > 0) {
                 if (levyConcData.GroupDis.ReturnPtc > this.state.returnTripDiscPer) {
                   discountAmt = Math.floor(((el.BaseFare + totalPickdropCharge) * levyConcData.GroupDis.ReturnPtc) / 100);
                 } else {
                   discountAmt = Math.floor(((el.BaseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100);
                 }
 
                 groupDiscount += discountAmt;
               }
             } else {
               if (levyConcData.GroupDis.OnwardPtc > 0) {
 
                 discountAmt = Math.floor(((el.BaseFare + totalPickdropCharge) * levyConcData.GroupDis.OnwardPtc) / 100);
                 //console.log("discAmt", discountAmt);
                 groupDiscount += discountAmt;
               }
             }
 
           }
         })
       } else {
         if (this.props.search.searchParams.token) {
           selSeats.forEach((el) => {
             if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
               discountAmt = Math.floor(((el.BaseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100);
               groupDiscount += discountAmt;
             }
           })
         }
       }
     }
     groupDiscount = Math.floor(groupDiscount)
     this.setState({ groupDiscount })
   } */


  /*  updateOnwardSeatWiseGstNDiscount = (onwardSeats, onwardConLevy, type) => {
     const onwardSeatCount = this.state.selSeat.length
     //console.log("onwardConLevy", onwardConLevy);
     //console.log("count number of seats -> ", onwardSeatCount);
 
     const { pickCharge, dropCharge } = this.state;
     //console.log("pick", { pickCharge, dropCharge })
     //for get corporation lavy ids
     let coLavyIds = "";
     if (
       onwardConLevy && Object.keys(onwardConLevy).length > 0 &&
       onwardConLevy.ConcessionList && onwardConLevy.ConcessionList.length > 0
     ) {
       Object.entries(onwardConLevy.ConcessionList).forEach(([cInd, cObj]) => {
         if (cObj.ConcessionTypeName == 'GENERAL PUBLIC') {
           coLavyIds = cObj.CorporationLavyIDs;
         }
       });
     }
 
     //console.log('coLavyIds', coLavyIds);
 
     var discountAmt = 0;
     var totalDiscAmt = 0;
     if (this.props.search.searchParams.token && onwardSeatCount < 4) {
       let disBaseFare = onwardSeats.baseFare + pickCharge + dropCharge;
       discountAmt = Math.floor(
         (disBaseFare * this.state.returnTripDiscPer) / 100
       );
     } else {
       if (
         onwardConLevy && Object.keys(onwardConLevy).length > 0 &&
         onwardConLevy.GroupDis && Object.keys(onwardConLevy.GroupDis).length > 0 &&
         onwardSeatCount >= onwardConLevy.GroupDis.MinSeat
       ) {
         //console.log("discount applicable");
 
         let disBaseFare = onwardSeats.baseFare + pickCharge + dropCharge;
         if (this.props.search.searchParams.token) {
 
           if (disBaseFare > 0 && onwardConLevy.GroupDis.ReturnPtc > 0) {
             if (onwardConLevy.GroupDis.ReturnPtc > this.state.returnTripDiscPer) {
               discountAmt = Math.floor(
                 (disBaseFare * onwardConLevy.GroupDis.ReturnPtc) / 100
               );
             } else {
               discountAmt = Math.floor(
                 (disBaseFare * this.state.returnTripDiscPer) / 100
               );
             }
           }
         } else {
           if (disBaseFare > 0 && onwardConLevy.GroupDis.OnwardPtc > 0) {
             discountAmt = Math.floor(
               (disBaseFare * onwardConLevy.GroupDis.OnwardPtc) / 100
             );
           }
         }
       } else {
         if (this.props.search.searchParams.token && onwardConLevy.GroupDis == null) {
           let disBaseFare = onwardSeats.baseFare + pickCharge + dropCharge;
           discountAmt = Math.floor(
             (disBaseFare * this.state.returnTripDiscPer) / 100
           );
         }
       }
     }
 
     var gstPer = 0;
     var gstIsPer = 0;
 
     //this code is used to get gst percentage from leavy list , where leavy name is GST
     if (
       onwardConLevy && Object.keys(onwardConLevy).length > 0 &&
       onwardConLevy.LevyList && onwardConLevy.LevyList.length > 0
     ) {
       onwardSeats.l = [];
       Object.entries(onwardConLevy.LevyList).forEach(([levyInd, levyObj]) => {
         //if corporatin levy id match with concession corporation levy id then only calculate leavy 
         if (coLavyIds.includes(levyObj.CorporationLevyID)) {
           let fare = 0;
           let levyAmt = 0;
           let calLevyAmt = 0;
 
           fare = onwardSeats.baseFare + pickCharge + dropCharge;
           levyAmt = levyObj.AdultAmount;
 
           if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
             if (levyObj.IsPercentage === 0) {
               calLevyAmt = levyAmt;
             } else {
               calLevyAmt = Math.round((fare * levyAmt) / 100);
             }
           }
           onwardSeats.l.push({
             n: levyObj.LevyName,
             a: calLevyAmt,
           });
         }
       });
 
       Object.entries(onwardConLevy.LevyList).forEach(([levyInd, levyObj]) => {
         if (coLavyIds.includes(levyObj.CorporationLevyID)) {
           if (levyObj.LevyName == "GST") {
             let fare = 0;
             let levyAmt = 0;
             fare = onwardSeats.baseFare + pickCharge + dropCharge;
             levyAmt = levyObj.AdultAmount;
 
             if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
               if (levyObj.IsPercentage === 0) {
                 gstPer = levyAmt;
                 gstIsPer = 0;
               } else {
                 gstPer = levyAmt;
                 gstIsPer = 1;
               }
             }
           }
         }
       })
     }
 
     //console.log("gstPer", gstPer);
     //console.log("gstIsPer", gstIsPer);
 
     var baseFare = onwardSeats.baseFare + pickCharge + dropCharge;
 
     //console.log("basefare", baseFare);
 
     //for calculate total leavy amt
     var totLeavyAmt = 0;
     if (onwardSeats.l && onwardSeats.l.length > 0) {
       onwardSeats.l.forEach((ol) => {
         if (ol.n !== 'GST') {
           totLeavyAmt += ol.a;
         }
       });
     }
 
     //console.log("totLeavyAmt", totLeavyAmt);
 
     var totCancessionAmt = 0;
 
     let orderData = this.state.orderData;
     if (Object.keys(orderData).length > 0) {
       let onward = orderData.onward;
       let seatDetails = onward.seatDetails;
 
       Object.keys(seatDetails).forEach(el => {
         if (el == onwardSeats.seatLabel) {
           let conc = onwardSeats[el].c || []
           if (conc.length > 0) {
             conc.forEach(c => totCancessionAmt += c.a)
           }
         }
       })
     }
 
     if (this.props.search.searchParams.token) {
       totCancessionAmt = 0;
       if (Object.keys(orderData).length > 0) {
         let ret = orderData.return;
         let seatDetails = ret.seatDetails;
 
         Object.keys(seatDetails).forEach(el => {
           if (el == onwardSeats.seatLabel) {
             let conc = onwardSeats[el].c || []
             if (conc.length > 0) {
               conc.forEach(c => totCancessionAmt += c.a)
             }
           }
         })
       }
     }
 
     //for whose amount is greater use this amount either concession or discount
     if (discountAmt > totCancessionAmt) {
       totCancessionAmt = 0;
     } else {
       discountAmt = 0;
     }
 
     //for calculate total concession amt
 
     var totForGst = baseFare + totLeavyAmt - discountAmt;
 
     //console.log("totForGst", totForGst);
     var gst = 0;
     var seatWiseIGst = 0;
     var seatWiseCGst = 0;
     var seatWiseSGst = 0;
 
     if (
       Object.keys(onwardConLevy).length > 0 &&
       onwardConLevy.GSTInfo &&
       Object.keys(onwardConLevy.GSTInfo).length > 0
     ) {
       //corporation has gst for state
       if (
         onwardConLevy.GSTInfo.GSTN != "" &&
         onwardConLevy.GSTInfo.GSTStateCode != ""
       ) {
         //console.log(onwardConLevy.GSTInfo);
         //console.log(onwardConLevy.GSTInfo.GSTN);
         //console.log(onwardConLevy.GSTInfo.GSTStateCode);
         //if customer has gst number
 
         //customer not have gst then cgst and sgst
         //console.log("customer not have gst then cgst and sgst");
         if (gstIsPer == 1) {
           seatWiseCGst = Math.ceil((totForGst * gstPer) / 100 / 2);
           seatWiseSGst = Math.ceil((totForGst * gstPer) / 100 / 2);
         } else {
           seatWiseCGst = Math.ceil(gstPer / 2);
           seatWiseSGst = Math.ceil(gstPer / 2);
         }
       }
     } else {
       //corporation does not have gst then calculate IGST
       //console.log("corporation does not have gst then calculate IGST");
       if (gstIsPer == 1) {
         seatWiseIGst = Math.ceil((totForGst * gstPer) / 100);
       } else {
         seatWiseIGst = gstPer;
       }
     }
 
     if (seatWiseIGst > 0) {
       gst = seatWiseIGst;
     }
     else {
       gst = seatWiseCGst + seatWiseSGst;
     }
 
     //console.log("seatWiseIGst", seatWiseIGst);
     //console.log("seatWiseCGst", seatWiseCGst);
     //console.log("seatWiseSGst", seatWiseSGst);
     //console.log("discountAmt", discountAmt);
 
     // onwardSeats.IGST = seatWiseIGst;
     // onwardSeats.CGST = seatWiseCGst;
     // onwardSeats.SGST = seatWiseSGst;
     onwardSeats.calGst = gst;
     onwardSeats.GroupDiscount = discountAmt;
 
     if (onwardSeats.l && onwardSeats.l.length > 0) {
       onwardSeats.l.forEach((ol) => {
         if (ol.n == 'GST') {
           ol.a = gst;
         }
       });
     }
 
     // this.setState({ groupDiscount: discountAmt * onwardSeatCount })
     // console.log("onwardSeats", onwardSeats)
   }; */


  getPickupId = (BusID, jDate) => {
    const url = window.url + apiUrl.getPickUpID + '?BusID=' + BusID + '&Date=' + jDate;
    fetchGet(url)
      .then((response) => {
        const pickupRes = JSON.parse(response);
        //console.log(pickupRes);
        if (pickupRes?.Success) {
          const pickupData = pickupRes.data;
          this.setState({ pickupData })
        } else {
          this.setState({ pickupData: [] })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getFare = () => {

    const jDate = this.props.search.searchParams.jDate;
    const BusID = this.props.seat.BusID;
    const variantCode = this.props.search.searchParams.variantCode;
    const accoTypeApplicable = this.props.seat.AccoTypeApplicable;

    let accoType = 0;
    if (accoTypeApplicable == 'YES') {
      if (this.state.selAccoType.AccoCode == '1') {
        accoType = 1;
      } else if (this.state.selAccoType.AccoCode == '2') {
        accoType = 2;
      } else if (this.state.selAccoType.AccoCode == '3') {
        accoType = 3;
      }
    }

    this.setState({ showLoader: true });

    const url = window.url + apiUrl.getFare + '?Date=' + jDate + '&BusID=' + BusID + '&Adult=1&AccoType=' + accoType + '&VariantCode=' + variantCode;

    fetchGet(url)
      .then((response) => {
        const seatFareRes = JSON.parse(response);
        //console.log(pickupRes);
        if (seatFareRes?.Success) {
          const seatFareData = seatFareRes?.data?.[0];
          const seatWiseFare = seatFareData?.TotalFare;
          this.setState({ seatWiseFare })
        } else {
          this.setState({ seatWiseFare: 0 })
        }

        this.setState({ showLoader: false });

      })
      .catch((err) => {
        console.log(err)
        this.setState({ showLoader: false });
      })
  }


  getSeniorFare = () => {

    const jDate = this.props.search.searchParams.jDate;
    const BusID = this.props.seat.BusID;
    const variantCode = this.props.search.searchParams.variantCode;
    const accoTypeApplicable = this.props.seat.AccoTypeApplicable;

    let accoType = 0;
    if (accoTypeApplicable == 'YES') {
      if (this.state.selAccoType.AccoCode == '1') {
        accoType = 1;
      } else if (this.state.selAccoType.AccoCode == '2') {
        accoType = 2;
      } else if (this.state.selAccoType.AccoCode == '3') {
        accoType = 3;
      }
    }

    this.setState({ showLoader: true });

    const url = window.url + apiUrl.getSeniorFare + '?Date=' + jDate + '&BusID=' + BusID + '&Adult=1&AccoType=' + accoType + '&VariantCode=' + variantCode;

    fetchGet(url)
      .then((response) => {
        const seatSrFareRes = JSON.parse(response);
        //console.log(pickupRes);
        if (seatSrFareRes?.Success) {
          const seatSrFareData = seatSrFareRes?.data?.[0];
          const seatWiseSrFare = seatSrFareData?.TotalFare;
          this.setState({ seatWiseSrFare })
        } else {
          this.setState({ seatWiseSrFare: 0 })
        }

        this.setState({ showLoader: false });

      })
      .catch((err) => {
        console.log(err);
        this.setState({ showLoader: false });
      })
  }

  parseSeats = () => {
    let lower = {};
    let upper = {};
    let fares = [];
    let countLower = this.state.countLower;
    let countUpper = this.state.countUpper;
    const st = this.state.stchrt;

    st.forEach((el) => {

      /* if (el.baseFare !== 0 && fares.indexOf(el.baseFare) === -1) {
        fares.push(el.baseFare);
      } */

      if (Number(el.LEVEL) === 1) {

        if (Number(el.BookingStatusId) === 5 && el.Seat) {
          countLower++;
        }

        if (Object.keys(lower).indexOf(el.COLUMN + "") === -1) {
          lower[el.COLUMN] = [];
        }

        if(Number(el.SeatNumber) > 100){
          el.BookingStatusId = 10;
        }

        if (el.Seat) {
          lower[el.COLUMN].push(el);
        }

      } else {

        if (Number(el.BookingStatusId) === 5 && el.Seat) {
          countUpper++;
        }

        if (Object.keys(upper).indexOf(el.COLUMN + "") === -1) {
          upper[el.COLUMN] = [];
        }

        if(Number(el.SeatNumber) > 100){
          el.BookingStatusId = 10;
        }

        if (el.Seat) {
          upper[el.COLUMN].push(el);
        }
      }
    });

    lower = this.parseSt(lower);
    upper = this.parseSt(upper);

    const stchrt = { lower, upper };
    this.setState({ stchrt, fares, countLower, countUpper });

  };

  parseSt = (val) => {
    let keys = Object.keys(val);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i + 1] - keys[i] > 1) {
        val[parseInt(keys[i], 10) + 1] = false;
      }
      if (
        val[keys[i]] &&
        val[keys[i]].length === 0 &&
        val[keys[i + 1]] &&
        val[keys[i + 1]].length === 0
      ) {
        val[keys[i]] = false;
        delete val[keys[i + 1]];
      }
    }
    return val;
  };

  getHeightForDiv = (el) => {
    for (let i = 0; i < el.length; i++) {
      //if (el[i].Width === 1) {
      return "40px";
      //} else {
      //return "70px";
      //}
    }
    return "40px";
  };

  calSeatLabel = (busType, deck) => {

    const isHybridBus = busType && busType.includes('HYBRID') ? true : false;
    //const isSleeperBus = busType && busType.includes('SWIFT-GAJARAJ MULTI AXLE VOLVO A/C SLEEPER BUS') ? true : false;
    const isSleeperBus = busType && busType.includes('SLEEPER') ? true : false;

    let seatLabel = '';
    if (isHybridBus && deck === 'lower') {
      seatLabel = t(SEATER);
    } else if (isHybridBus && deck === 'upper') {
      seatLabel = t(BERTH);
    } else if (isSleeperBus) {
      seatLabel = t(BERTH);
    } else {
      seatLabel = t(SEATER);
    }
    return seatLabel;
  }

  showLowerSt = () => {

    const loop = this.state.stchrt.lower;
    const busType = this.props.search.busType;
    const seatlabel = this.calSeatLabel(busType, 'lower');
    const isSleeperBus = busType && busType.includes('SLEEPER') ? true : false;

    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column-reverse",
          justifyContent: "flex-end",
          background: color.white,
          padding: "10px 5px 10px 60px",
          marginBottom: "10px",
          boxShadow: "0 0 2px rgba(0, 0, 0, 0.3)",
          borderRadius: color.borderRadius,
          height:
            this.state.stchrt.upper &&
              Object.keys(this.state.stchrt.upper).length > 0
              ? "unset"
              : "100%",
        }}
      >
        {this.props.DefaultCurrencyID !== 2 ? (
          <span className="seatchart-label">
            {isSleeperBus && t(LOWER)} {seatlabel} ({this.state.countLower})
          </span>
        ) : (
          ""
        )}

        {renderImg('WheelIcon')}

        {this.state.seaterror ? this.showerror() : ""}

        {Object.keys(loop).map((el, index) => {
          if (loop[el] && loop[el].length > 0) {
            return (
              <div
                key={index}
                style={{
                  position: "relative",
                  display: "flex",
                  height: this.getHeightForDiv(loop[el]),
                }}
              >
                {loop[el].map((ell, indexx) => {

                  //const seatcolor = ell.Gender === "F" ? color.female : this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? color.chekColor : color.green;
                  const seatcolor = color.green;

                  return (
                    <div
                      key={indexx}
                      style={this.generateSeatStyle(ell)}
                      onClick={() => this.onSelectSeat(ell)}
                      className="seatlook"
                    >
                      {ell.SeatNumber}
                      {Number(ell.BookingStatusId) === 5 ? (
                        <span
                          style={{
                            position: "absolute",
                            right: "0",
                            top: "5px",
                            bottom: "3px",
                            left: "initial",
                            width: "5px",
                            height: "initial",
                            background: seatcolor,
                          }}
                        ></span>
                      ) : (
                        ""
                      )}

                      <div
                        style={{
                          position: "absolute",
                          top: "35px",
                          right:
                            Object.keys(loop[el]).length / (indexx + 1) > 1.5
                              ? "unset"
                              : "0",
                          left:
                            Object.keys(loop[el]).length / (indexx + 1) > 1.5
                              ? "0"
                              : "unset",
                          width: "max-content",
                          height: "30px",
                          border: "1px solid #f14f22",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#000",
                          fontSize: "0.75em",
                          padding: "0 10px",
                        }}
                        className="farepopup"
                      >
                        {"Seat: "}
                        {ell.SeatNumber}{" "}
                        {/*"| Fare: Rs."}{" "}
                      {ell.baseFare*/}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          } else {
            return <div key={index} style={{ height: "30px" }}></div>;
          }
        })}
      </div>
    );
  };

  showUpperSt = () => {
    const loop = this.state.stchrt.upper;
    const busType = this.props.search.busType;
    const seatlabel = this.calSeatLabel(busType, 'upper');
    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column-reverse",
          justifyContent: "flex-end",
          background: color.white,
          padding: "10px 5px 10px 60px",
          boxShadow: "0 0 2px rgba(0, 0, 0, 0.3)",
          borderRadius: color.borderRadius,
        }}
      >
        {this.props.DefaultCurrencyID !== 2 ? (
          <span className="seatchart-label up">
            {t(UPPER)} {seatlabel} ({this.state.countUpper} )
          </span>
        ) : (
          ""
        )}
        {Object.keys(loop).map((el, index) => {
          if (loop[el] && loop[el].length > 0) {
            return (
              <div
                key={index}
                style={{
                  position: "relative",
                  display: "flex",
                  height: this.getHeightForDiv(loop[el]),
                }}
              >
                {loop[el].map((ell, indexx) => {
                  /* const seatcolor =
                    ell.Gender === "F"
                      ? color.female
                      : this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? color.chekColor : color.green;
 */
                  const seatcolor = color.green;
                  return (
                    <div
                      key={indexx}
                      style={this.generateSeatStyle(ell)}
                      onClick={() => this.onSelectSeat(ell)}
                      className="seatlook"
                    >
                      {ell.SeatNumber}
                      {Number(ell.BookingStatusId) === 5 ? (
                        <span
                          style={{
                            position: "absolute",
                            right: "0",
                            top: "5px",
                            bottom: "3px",
                            left: "initial",
                            width: "5px",
                            height: "initial",
                            background: seatcolor,
                          }}
                        ></span>
                      ) : (
                        ""
                      )}
                      <div
                        style={{
                          position: "absolute",
                          top: "-35px",
                          right:
                            Object.keys(loop[el]).length / (indexx + 1) > 1.5
                              ? "unset"
                              : "0",
                          left:
                            Object.keys(loop[el]).length / (indexx + 1) > 1.5
                              ? "0"
                              : "unset",
                          width: "max-content",
                          height: "30px",
                          border: "1px solid #f14f22",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#000",
                          fontSize: "0.75em",
                          padding: "0 10px",
                        }}
                        className="farepopup"
                      >
                        {"Seat: "}
                        {ell.SeatNumber}{" "}
                        {/*"| Fare: Rs."}{" "}
                      {ell.baseFare*/}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          } else {
            return <div key={index} style={{ height: "30px" }}></div>;
          }
        })}
      </div>
    );
  };

  showerror = () => {
    setTimeout(() => {
      this.setState({ seaterror: false });
    }, 5000);
    return (
      <div
        className="errorblock"
        style={{
          bottom:
            this.state.stchrt.upper &&
              Object.keys(this.state.stchrt.upper).length > 0
              ? "-20px"
              : "10px",
        }}
      >
        6 seats are allowed per booking,for more seats please go for multiple
        booking
      </div>
    );
  };

  savePackageOrder = () => {

    const srchPrms = this.props.search.searchParams;

    if (this.state.selSeat.length > 0 && this.state.selPick !== "") {

      const that = this;

      const tourBus = this.props.search.tourPackages.filter(function (a) {
        return that.props.seat.TripRouteID === a.TripRouteID;
      })[0];

      const pick = this.state.selPick;
      const source = localStorage.getItem("source");
      const accoType = this.state.selAccoType;

      let orderPostData = {
        ServiceType: tourBus.BusTypeDescription,
        TripCode: tourBus.RouteNumber,
        fromCity: tourBus.CityTownFrom,
        fromCityId: tourBus.CityTownIDFrom,
        toCity: tourBus.CityTownTo,
        toCityId: tourBus.CityTownIDTo,
        ip_address: this.state.ip_address,
        variantCode: srchPrms?.variantCode,
        journeyDate: getRevDate(srchPrms.jDate),
        tripRouteIDMain: tourBus.TripRouteID,
        packageName:tourBus.CTDescription,
        busID: tourBus.BusID,
        days: tourBus.DaysOfOperation,
        isAccomodationApplicable: tourBus.AccoTypeApplicable,
        AccomodationTypeID: accoType?.AccoCode || "",
        AccomodationType: accoType?.AccoTypeDescription || "",
        pickUpID: pick?.TripRouteCityTownAreaID || '',
        pickUpName: pick?.NameLandMark || '',
        pickUpTime: convertToTime(pick?.Time) || '',
      }

      if (source === 'ios') {
        orderPostData["source"] = 'ios';
      }

      const seatChartData = this.state.seatchart;
      let index = 0;

      seatChartData.forEach((el) => {

        if (this.state.selSeat.indexOf(el.SeatNumber) >= 0) {
          orderPostData["seats[" + index + "]"] = el.SeatNumber;
          orderPostData["gender[" + index + "]"] = "";
          orderPostData["isSleeper[" + index + "]"] = false;
          orderPostData["isAC[" + index + "]"] = false;
          orderPostData["hasSTax[" + index + "]"] = false;
          orderPostData["serviceTax[" + index + "]"] = 0;//el.ServiceTax;
          orderPostData["hasSCharge[" + index + "]"] = false;
          orderPostData["serviceCharge[" + index + "]"] = 0;//el.ServiceCharge;
          orderPostData["price[" + index + "]"] = this.state.seatWiseFare;;
          orderPostData['childPrice[' + index + ']'] = this.state.seatWiseFare;;
          orderPostData['seniorPrice[' + index + ']'] = this.state.seatWiseSrFare;
          orderPostData['busIdPrice[' + index + ']'] = this.state.busIdFarePerSeat;
          index++;
        }
      });

      if (srchPrms.token) {
        orderPostData["token"] = srchPrms.token;
      }

      //console.log("orderPostData", orderPostData);

      let showPassenger = that.props.search.showPassenger;
      showPassenger[tourBus.TripRouteID] = true;
      store.dispatch(updateShowpassenger(showPassenger));

      const url = window.url + apiUrl.packageOrderSave;

      fetchPost(url, orderPostData)
        .then((data) => {

          Object.keys(data.orderData.onward.seatDetails).forEach((el) => {
            data.orderData.onward.seatDetails[el]["name"] = "";
            data.orderData.onward.seatDetails[el]["age"] = "";
          });

          // that.setState({ showPassenger: true })
          store.dispatch(updateCheckoutDet(data.orderData));
          store.dispatch(updateOrderToken(data.orderToken));

        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  HandleEnterSaveOrder = (e) => {
    let that = this;

    const tourBus = this.props.search.tourPackages.filter(function (a) {
      return that.props.seat.TripRouteID === a.TripRouteID;
    })[0];

    if (e.key === 'Enter') {
      if (Object.keys(this.props.search.order).length > 0) {
        store.dispatch(updateCheckoutDet([]));
        let showPassenger = that.props.search.showPassenger;
        showPassenger[tourBus.TripRouteID] = false;
        store.dispatch(updateShowpassenger(showPassenger));
      } else {
        this.savePackageOrder();
      }
    }
  }

  handleredirect = (data, mode, isGenderCheck) => {
    let prop = this.props.search.searchParams;
    let { linkfromstoptocity } = prop;
    let isSeamlesspg = this.state.ismantispg;
    let url = "";
    // if (isSeamlesspg) {
    //   const hostname = window.location.hostname;
    //   const coString = "/co/seamless/" + data.orderToken;
    //   const genderstring = "?p=" + isGenderCheck;
    //   const logintoken = "token=" + this.state.logintoken;
    //   let windowurl = "";
    //   if (window.location.hostname.includes("dev.", 0)) {
    //     windowurl = "http://dev.checkout.iamgds.com";
    //   } else if (window.location.hostname.includes("beta.", 0)) {
    //     windowurl = "http://beta.checkout.iamgds.com";
    //   } else {
    //     windowurl = "https://checkout.iamgds.com";
    //   }

    //   if (mode === "roundtrip") {
    //     url = windowurl + coString + "?" + logintoken;
    //   } else {
    //     url = windowurl + coString + genderstring + "&" + logintoken;
    //   }
    //   window.location.href = url;
    // } else {
    if (mode === 'roundtrip' && linkfromstoptocity) {
      // this.props.history.push("/co/exp/" + data.orderToken + '?linkfromstoptocity=' + linkfromstoptocity);
    } else {
      if (mode === "roundtrip") {
        // this.props.history.push("/co/exp/" + data.orderToken);
      } else {
        // this.props.history.push(
        //   "/co/exp/" + data.orderToken + "?p=" + isGenderCheck
        // );
        // this.setState({ showPassenger: true })
      }
    }
    // }
  };

  showBoardingDropDown = () => {
    return (
      <div className="points"
        onKeyDown={(event) => this.handleKeyDown(event, "pick")}
      >
        <div
          className={
            this.state.showPoint === "pick"
              ? "point-inp flex-vc active"
              : "point-inp flex-vc"
          }
          ref={this.pickupDropdownRef}
          onClick={() => this.setState({ showPoint: "pick" })}
          tabIndex={0}
        >
          <div
            className={
              this.state.selPick !== "" || this.state.showPoint === "pick" ? "picklabel-active" : "picklabel"
            }
          >
            Boarding Point
          </div>
          <span></span>
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontSize: "0.8em",
              width: "90%",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            {this.state.selPick === "" ? "" : this.state.selPick.NameLandMark}
          </div>
        </div>
        <div className="point-sel" style={{ fontSize: "0.75em", paddingTop: "5px" }}>
          {this.state.selPick === "" ? "" : this.state.selPick.NameLandMark}
        </div>
        {this.state.showPoint === "pick" && this.showPoint("pick")}
      </div>
    )
  }

  onSelectBoardingPoint = (el) => {
    this.setState({
      selPick: el,
      showPoint: "",
    });
  };

  showPoint = (pointtype) => {

    const { showPoint, pickupData } = this.state;

    if (showPoint == "pick" && pickupData && pickupData.length > 0) {
      return (
        <div className="point-opt active">
          {pickupData.map((el, index) => {
            return (
              <div
                className={`${this.state.showPoint}--val`}
                key={index}
                onClick={() => {
                  this.onSelectBoardingPoint(
                    el
                  );
                }
                }
                tabIndex={-1}
              >
                <div>{el.NameLandMark}</div>
              </div>
            );
          })}
        </div>
      );
    } else {
      return <div className="point-opt"></div>;
    }
  };

  showAccoTypeDropDown = () => {
    return (
      <div className="points accoType"
        onKeyDown={(event) => this.handleKeyDown(event, "acco_type")}
      >
        <div
          className={
            this.state.showAccoType === true
              ? "point-inp flex-vc active"
              : "point-inp flex-vc"
          }
          ref={this.pickupDropdownRef}
          onClick={() => this.setState({ showAccoType: true })}
          tabIndex={0}
        >
          <div
            className={
              this.state.selAccoType !== "" || this.state.showAccoType === true ? "picklabel-active" : "picklabel"
            }
          >
            Accommodation Type
          </div>
          <span></span>
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontSize: "0.8em",
              width: "90%",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            {this.state.selAccoType === "" ? "" : this.state.selAccoType.AccoTypeDescription}
          </div>
        </div>
        {this.state.showAccoType === true && this.showAccoType()}
      </div>
    )
  }

  onSelectAccoType = (el) => {

    this.setState({
      selAccoType: el,
      showAccoType: false,
      selNoOfPax: 0,
      noOfPaxData: [],
      showNoOfPax: false,
    });

    setTimeout(() => {

      //for get fare
      this.getFare();

      //for get sr fare
      this.getSeniorFare();

      this.setState({
        selSeat: [],
        totalSeat: 0,
        totSeatFare: 0,
      })

    }, 0);

  };

  showAccoType = () => {

    const accoTypeData = this.props.search.accoTypeData;
    const { showAccoType } = this.state;

    if (showAccoType && accoTypeData && accoTypeData.length > 0) {
      return (
        <div className="point-opt active">
          {accoTypeData.map((el, index) => {
            return (
              <div
                className={`--val`}
                key={index}
                onClick={() => {
                  this.onSelectAccoType(
                    el
                  );
                }
                }
                tabIndex={-1}
              >
                <div>{el.AccoTypeDescription}</div>
              </div>
            );
          })}
        </div>
      );
    } else {
      return <div className="point-opt"></div>;
    }
  };

  showNoOfPaxDropDown = () => {
    return (
      <div className="points noOfPax"
        onKeyDown={(event) => this.handleKeyDown(event, "no_of_pax")}
      >
        <div
          className={
            this.state.showNoOfPax === true
              ? "point-inp flex-vc active"
              : "point-inp flex-vc"
          }
          ref={this.pickupDropdownRef}
          onClick={() => this.setState({ showNoOfPax: true })}
          tabIndex={0}
        >
          <div
            className={
              this.state.selNoOfPax !== 0 || this.state.showNoOfPax === true ? "picklabel-active" : "picklabel"
            }
          >
            No. of PAX (Adults + Child)
          </div>
          <span></span>
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontSize: "0.8em",
              width: "90%",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            {this.state.selNoOfPax === 0 ? "" : this.state.selNoOfPax}
          </div>
        </div>
        {this.state.showNoOfPax === true && this.showNoOfPax()}
      </div>
    )
  }

  showNoOfPax = () => {

    const { selAccoType, showNoOfPax } = this.state;
    const accoTypeApplicable = this.props.seat.AccoTypeApplicable;

    let noOfPaxData = [];

    if (selAccoType.AccoCode == '1' || accoTypeApplicable == 'NO') {
      noOfPaxData = [1, 2, 3, 4, 5, 6];
    } else if (selAccoType.AccoCode == '2') {
      noOfPaxData = [2, 4, 6];
    } else if (selAccoType.AccoCode == '3') {
      noOfPaxData = [3, 6];
    } else {
      noOfPaxData = [];
    }

    if (showNoOfPax && noOfPaxData && noOfPaxData.length > 0) {
      return (
        <div className="point-opt active">
          {noOfPaxData.map((el, index) => {
            return (
              <div
                className={`--val`}
                key={index}
                onClick={() => {
                  this.onSelectNoOfPax(
                    el
                  );
                }
                }
                tabIndex={-1}
              >
                <div>{el}</div>
              </div>
            );
          })}
        </div>
      );
    } else {
      return <div className="point-opt"></div>;
    }
  };

  onSelectNoOfPax = (el) => {

    this.setState({
      selNoOfPax: el,
      showNoOfPax: false,
    });

    setTimeout(() => {
      this.setState({
        selSeat: [],
        totalSeat: 0,
        totSeatFare: 0,
      })
    }, 0);

  };

  showPick = () => {

    const prop = this.props.search.searchParams;

    //const returnChartSeatRestrictionFlag = this.state.returnChartSeatRestrictionFlag;
    //const totalOnwardSeats = this.state.totalOnwardSeats;
    //const remainingSeats = totalOnwardSeats - this.state.selSeat.length;
    //const roundtripSeatselFlag = (returnChartSeatRestrictionFlag && remainingSeats === 0) ? true : false;
    const seatsCountValidFlag = this.state.selSeat.length > 0;
    const that = this;

    const tourBus = this.props.search.tourPackages.filter(function (a) {
      return that.props.seat.TripRouteID === a.TripRouteID;
    })[0];

    const accoTypeApplicable = this.props.seat.AccoTypeApplicable;

    let move = prop.mode;

    if (Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[tourBus.TripRouteID]) {
      move = `${t(CLOSE_CUSTOMER_DETAILS)}`
    } else {
      move = `${t(PROVIDE_PASSENGER_DETAILS)}`;
    }

    return (
      <div className="pickups"
        onKeyDown={(event) => this.state.showPoint === 'drop' && this.handleKeyDown(event, "drop")}>
        <div>
          <div className="accoTypeNoOfPaxWrap">
            {accoTypeApplicable == "YES" && this.showAccoTypeDropDown()}
            {this.showNoOfPaxDropDown()}
          </div>
          {this.showBoardingDropDown()}
        </div>
        <div>
          {this.showSelSeats()}
          <div
            className="btnPassDetails"
            style={{
              padding: "15px 0",
              textAlign: "center",
              fontWeight: "bold",
              color: Object.keys(this.props.search.order).length > 0 ? "var(--ksrtcThColor2)" : seatsCountValidFlag && this.state.selPick !== "" ? color.white : "#888",
              background: Object.keys(this.props.search.order).length > 0 ? '#fff' : seatsCountValidFlag && this.state.selPick !== "" ? "var(--ksrtcThColor2)" : Object.keys(this.props.search.order).length > 0 ? '#fff' : "#ccc",
              marginTop: "7px",
              textTransform: "uppercase",
              borderRadius: color.borderRadius,
              cursor: seatsCountValidFlag && this.state.selPick !== "" ? "pointer" : "not-allowed",
              boxShadow: seatsCountValidFlag && this.state.selPick !== "" ? "none" : "none",
              pointerEvents: seatsCountValidFlag && this.state.selPick !== "" ? "auto" : "none",
              border: Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[tourBus.TripRouteID] ? `2px solid ${"var(--ksrtcThColor2)"}` : ''
            }}

            onClick={() => {
              if (Object.keys(this.props.search.order).length > 0) {
                store.dispatch(updateCheckoutDet([]));
                let showPassenger = that.props.search.showPassenger;
                showPassenger[tourBus.TripRouteID] = false;
                store.dispatch(updateShowpassenger(showPassenger));
              } else {
                this.savePackageOrder();
              }
            }}

            tabIndex={2}
            onKeyDown={(event) => this.HandleEnterSaveOrder(event)}
          >
            {this.state.selPick !== "" ? move :
              `${t(SELECT)} 
              ${(accoTypeApplicable == "YES" && this.state.selAccoType == '') ? "Accommodation," : ""} 
              ${this.state.selNoOfPax == 0 ? "PAX," : ""} 
              ${this.state.selPick === "" ? "Boarding Point," : ""}
              ${this.state.selSeat.length === 0 ? t(SEATS) : ""}`}
          </div>
        </div>
        {this.state.showPoint === 'drop' && this.showPoint("drop")}
        {/* this.state.openfareModal && this.state.selSeat.length > 0 && this.showFareDetails() */}
      </div>
    );
  };

  /*   showFareDetails = () => {
      // const { levyArray, levyNameArray } = this.state;
      const seats = this.state.selSeat.length || 0;
      const pickUpCharge = this.state.pickCharge * seats;
      const dropCharge = this.state.dropCharge * seats;
      let levyFare = {};
      const selSeats = this.state.seatchart.Seats;
      selSeats.forEach((el) => {
        if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
          let levyList = el.l || [];
          if (levyList.length > 0) {
            levyList.forEach((el) => {
              if (levyFare[el.n] != undefined) {
                levyFare[el.n] += el.a;
              } else {
                levyFare[el.n] = el.a;
              }
            })
          }
        }
      })
  
      let orderData = this.state.orderData;
      console.log("orderData", orderData);
      let concessionAmt = 0;
      if (Object.keys(orderData).length > 0) {
        let onward = orderData.onward;
        let seatDetails = onward.seatDetails;
  
        Object.keys(seatDetails).forEach(el => {
          let conc = seatDetails[el].c || [];
          conc.forEach(c => concessionAmt += c.a)
        })
      }
      let rtConCessionAmt = 0;
      if (orderData.return) {
        //console.log("hi i am in")
        if (Object.keys(orderData).length > 0) {
          let ret = orderData.return;
          let seatDetails = ret.seatDetails;
  
          Object.keys(seatDetails).forEach(el => {
            let conc = seatDetails[el].c || [];
            conc.forEach(c => rtConCessionAmt += c.a)
          })
        }
      }
  
      // console.log({ levyArray, levyNameArray });
      return (
        <div className={`chart-fare-details active`}>
          <div className="chart-fare-header">{t(TOTAL_FARE_DETAILS)}</div>
          <div className="chart-fare-container">
            <div className="chart-fare">
              <div>ಮೂಲ ದರ / Original Basic Fare</div>
              <div>{this.props.search.currency}{this.state.baseFare + pickUpCharge + dropCharge}</div>
            </div>
            <div className="chart-fare">
              <div>ರಿಯಾಯಿತಿ ಮೊತ್ತ / Concession Amount</div>
              <div>{"-"}{this.props.search.currency}{rtConCessionAmt > 0 ? rtConCessionAmt : concessionAmt}</div>
            </div>
            <div className="chart-fare">
              <div>ರಿಯಾಯಿತಿ / Discount</div>
              <div>{"-"}{this.props.search.currency}{this.state.groupDiscount > 0 ? this.state.groupDiscount : 0}</div>
            </div>
            {/* <div className="chart-fare">
              <div>ಸ.ಸೇ.ಶು / GST</div>
              <div>{this.props.search.currency}{this.state.gst}</div>
            </div> *}
            {
              this.state.levyTotal > 0 &&
              <div className="chart-fare">
                <div>ಇತರೆ ಶುಲ್ಕಗಳು / Levies</div>
                <div>{this.props.search.currency}{this.state.levyTotal}</div>
              </div>
            }
          </div>
          {/* <div className="last--list">
            <span style={{ fontSize: '12px', color: '#444' }}>{`( `}
              {
                levyNameArray.length > 0 ? (
                  levyNameArray.map((val, index) => (
                    <span style={{ fontSize: '12px', color: '#444' }} key={val}>
                      <span>{val}{":"}</span>
                      <span style={{ margin: '0 5px' }}>{levyArray[val]}{levyNameArray.length - 1 > index ? ";" : ''}</span>
                    </span>
                  ))
                ) : (null)
              }
              {` )`}</span>
          </div> *}
  
          {
            Object.keys(levyFare).length > 0 &&
            <div className="last--list">
              <span style={{ fontSize: '0.75em', color: '#444' }}>{`(`}
                {
                  Object.keys(levyFare).map((val, index) => (
                    <span style={{ color: '#444', fontWeight: '400' }} key={index}>
                      <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{val}{":"}</span>
                      <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{levyFare[val]}{Object.keys(levyFare).length - 1 < index ? ";" : ''}</span>
                    </span>
                  ))
                }
                {`)`}</span>
            </div>
  
          }
  
        </div>
      )
    } */

  showSelSeats = () => {

    if (this.state.selSeat.length > 0) {

      //let orderData = this.state.orderData;
      /* let concessionAmt = 0;
      if (Object.keys(orderData).length > 0) {
        let onward = orderData.onward;
        let seatDetails = onward.seatDetails;

        Object.keys(seatDetails).forEach(el => {
          let conc = seatDetails[el].c || [];
          conc.forEach(c => concessionAmt += c.a)
        })
      } */
      /* let rtConCessionAmt = 0;
      if (this.props.search.searchParams.token) {
        concessionAmt = 0;
        if (Object.keys(orderData).length > 0) {
          let ret = orderData.return;
          let seatDetails = ret.seatDetails;

          Object.keys(seatDetails).forEach(el => {
            let conc = seatDetails[el].c || [];
            conc.forEach(c => rtConCessionAmt += c.a)
          })
        }
      } */

      //const pickUpCharges = this.state.selSeat.length * this.state.pickCharge;
      //const dropCharges = this.state.selSeat.length * this.state.dropCharge;
      const selPaxSeats = this.state.selSeat;
      selPaxSeats.sort(customSort);

      return (
        <React.Fragment>
          <div className="flexed-justify pdinforow">
            <div>{selPaxSeats.join(", ")}</div>
            <div className="currentprice flex">
              <div>
                <span style={{ color: '#1A1A1A', fontWeight: '600' }}>{t(GRAND_TOTAL)}:{'\u00A0'}
                  {this.props.search.currency}
                  {this.state.totSeatFare}
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        ""
      );
    }
  };


  showReturnSelSeats = () => {
    const totalOnwardSeats = this.state.totalOnwardSeats;
    const remainingSeats = totalOnwardSeats - this.state.selSeat.length;
    let orderData = this.state.orderData;
    let rtConCessionAmt = 0;
    if (this.props.search.searchParams.token) {
      if (Object.keys(orderData).length > 0) {
        let ret = orderData.return;
        let seatDetails = ret.seatDetails;
        Object.keys(seatDetails).forEach(el => {
          let conc = seatDetails[el].c || [];
          conc.forEach(c => rtConCessionAmt += c.a)
        })
      }
    }

    const pickUpCharges = this.state.selSeat.length * this.state.pickCharge;
    const dropCharges = this.state.selSeat.length * this.state.dropCharge;
    const selPaxSeats = this.state.selSeat;
    selPaxSeats.sort(customSort);

    if ((remainingSeats === 0)) {
      return (
        <React.Fragment>
          {/* {parseInt(this.state.extraFare1) > 0 ||
            this.state.showlinkfromcity ? (
            <div className="flexed-justify pdinforow">
              <div>Link Ticket Service Charge</div>
              <div className="currentprice flex">
                <span>
                  {this.props.search.currency}
                  {parseInt(this.state.extraFare1) * this.state.totalSeat ||
                    parseInt(this.state.linkfare1) * this.state.totalSeat}
                </span>
              </div>
            </div>
          ) : (
            ""
          )}
          {parseInt(this.state.extraFare2) > 0 || this.state.showlinktocity ? (
            <div className="flexed-justify pdinforow">
              <div>Link Ticket Service Charge</div>
              <div className="currentprice flex">
                <span>
                  {this.props.search.currency}
                  {parseInt(this.state.extraFare2) * this.state.totalSeat ||
                    parseInt(this.state.linkfare2) * this.state.totalSeat}
                </span>
              </div>
            </div>
          ) : (
            ""
          )} */}
          <div className="flexed-justify pdinforow">
            <div>{/* this.state.selSeat.join(", ") */}{selPaxSeats.join(", ")}</div>
            <div className="currentprice flex">
              <div>
                <span style={{ color: '#1A1A1A', fontWeight: '600' }}>GRAND TOTAL:{'\u00A0'}
                  {this.props.search.currency}
                  {this.state.disSeatFare
                    ? this.state.disSeatFare + this.state.levyTotal - this.state.groupDiscount - rtConCessionAmt + pickUpCharges + dropCharges
                    : this.state.seatFare + this.state.levyTotal - this.state.groupDiscount - rtConCessionAmt + pickUpCharges + dropCharges}
                </span>
                <span>{'\u00A0'}{'\u00A0'}</span>
                <span
                  onClick={() => { this.setState({ openfareModal: !this.state.openfareModal }) }}
                  style={{ color: '#004F9E', fontSize: '0.875em', fontWeight: '500', cursor: 'pointer' }}
                >{"Show Details"}</span>
                {this.state.openfareModal ? <FareDownArrow /> : <FareUpArrow />}
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <div className="instructionmsg" style={{ display: 'flex', alignItems: 'center', background: '#FFE7E1', textAlign: 'left', fontWeight: '500', color: '#1A1A1A', fontSize: '0.875em', padding: '4px', borderRadius: '4px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '4px' }}>{renderImg('TripIcon')}</div>
          <div >Please select {remainingSeats} berth{remainingSeats > 1 ? 's' : ''}, pick up & drop off location to continue </div>
        </div>
      );
    }
  };

  handleKeyDown = (event, dropdownType) => {
    // console.log("event", event.key);
    const items = document.querySelectorAll(`.point-opt.active .${dropdownType}--val`);
    let currentItemIndex = dropdownType === 'pick' ? this.state.currentpickItemIndex : this.state.currentdropItemIndex;
    if (event.key === 'Tab') {
      event.preventDefault(); // Prevent default tab behavior
      this.setState({ showPoint: dropdownType })
    }
    if (items.length === 1) {
      currentItemIndex = 0;
      // this.setState({ [`current${dropdownType}ItemIndex`]: currentItemIndex })
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      // Move focus to the first item if no item is currently focused
      if (currentItemIndex < items.length - 1) {
        currentItemIndex++;
      } else {
        currentItemIndex = 0;
      }
      this.focusItem(items, currentItemIndex);
      this.setState({ [`current${dropdownType}ItemIndex`]: currentItemIndex })
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (currentItemIndex > 0) {
        currentItemIndex--;
      }
      this.focusItem(items, currentItemIndex);
      //this.setState({ currentItemIndex })
      this.setState({ [`current${dropdownType}ItemIndex`]: currentItemIndex })
    }
    if (event.key === 'Enter' && currentItemIndex >= 0) {
      // event.preventDefault();
      const selectedItem = items[currentItemIndex];
      if (selectedItem) {
        items[currentItemIndex].click();
      }
      if (dropdownType === 'pick') {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 2);
        if (target) {
          target.focus();
        }
        this.setState({ showPoint: 'drop' })
      }
      if (dropdownType === 'drop') {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 3);
        if (target) {
          target.focus();
        }
      }
    }

    if (event.key === 'Enter' && currentItemIndex <= 0) {
      // event.preventDefault();
      this.focusItem(items, 0);
      this.setState({ [`current${dropdownType}ItemIndex`]: 0 })
      const selectedItem = items[0];
      if (selectedItem) {
        items[0].click();
      }
      if (dropdownType === 'pick') {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 2);
        if (target) {
          target.focus();
        }
        setTimeout(() => {
          this.setState({ showPoint: 'drop' })
        }, 1000)
      }
      if (dropdownType === 'drop') {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 3);
        if (target) {
          target.focus();
        }
      }
    }

  };

  // Function to focus the item at the specified index
  focusItem = (items, index) => {
    if (items[index]) {
      // console.log("Focusing on item:", items[index].textContent); // Debugging
      items[index].focus(); // Focus on the item
    }
  };

  showLegend = () => {
    return (
      <div className="legend">
        <div>
          <span style={{ background: "#01AEF0", color: '#000' }}></span>
          {t(SELECTED)}
        </div>
        <div>
          <span style={{ background: color.alto, color: '#000' }}></span>
          {t(BOOKED)}

        </div>
        <div>
          <span className="st-legend" style={{ color: '#000' }}></span>{t(AVAILABLE)}
        </div>
        {/* {this.props.DefaultCurrencyID !== 2 ? (
          <div>
            <span style={{ background: color.male }}></span>
            Male
          </div>
        ) : (
          ""
        )} */}
        {this.props.DefaultCurrencyID !== 2 ? (
          <div>
            <span style={{ background: color.female }}></span>
            {t(FEMALE)}
          </div>
        ) : (
          ""
        )}
        {/* {this.state.HasSeater ? (
          <div>
            <span className="st-legend"></span>Seater
          </div>
        ) : (
          ""
        )} */}
        {/* {this.state.HasSleeper ? (
          <div>
            <span className="st-legend sl"></span>Sleeper
          </div>
        ) : (
          ""
        )} */}
        {this.state.Covid19Config ? (
          <div className="covid-legend">
            <ShieldNoBorder fillcolor="#1EB24B" style={{ marginRight: "5px" }} />
            COVID Safe Bus
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  //onclick seat
  onSelectSeat = (val) => {

    const that = this;
    let maxSeatSelect = 6;
    let selSeat = this.state.selSeat;
    let totSeatFare = this.state.totSeatFare;
    let seatWiseFare = this.state.seatWiseFare;
    let busIdFarePerSeat = this.state.busIdFarePerSeat;
    let selNoOfPax = this.state.selNoOfPax;

    const accoTypeApplicable = this.props.seat.AccoTypeApplicable;

    let accoType = 0;
    if (this.state.selAccoType?.AccoCode == '1') {
      accoType = 1;
    } else if (this.state.selAccoType?.AccoCode == '2') {
      accoType = 2;
    } else if (this.state.selAccoType?.AccoCode == '3') {
      accoType = 3;
    }

    const tourBus = this.props.search.tourPackages.filter(function (a) {
      return that.props.seat.TripRouteID === a.TripRouteID;
    })[0];

    //if seat is avialable for booking
    if (Number(val.BookingStatusId) === 5) {

      //for acco type applicable then handle validation here
      if (accoTypeApplicable == 'YES') {

        if (accoType == 0) {
          this.setState({ alerterror: "No of Passenger and No of seat should be same" });
          return false;
        }

        if (accoType > 1) {

          let totSelSeat = this.state.totalSeat;

          if (selNoOfPax == 0) {
            this.setState({ alerterror: "No of Passenger and No of seat should be same" });
            return false;
          }

          //for if seat is not already selected 
          if (selSeat.indexOf(val.SeatNumber) === -1) {
            if (parseInt(totSelSeat) + 1 > selNoOfPax) {
              this.setState({ alerterror: "No of Passenger and No of seat should be same" });
              return false;
            }
          }

        }
      }

      const index = selSeat.indexOf(val.SeatNumber);

      if (index === -1 && selSeat.length < maxSeatSelect) {
        selSeat.push(val.SeatNumber);

        // console.log("accoTypeApplicable",accoTypeApplicable);
        // console.log("seatWiseFare",seatWiseFare);
        // console.log("busIdFarePerSeat",busIdFarePerSeat);
        //for acco type yes take fare from api getFare
        //for acco type no take fare from getBusID api response and key is FarePerSeat
        if (accoTypeApplicable == 'YES') {
          totSeatFare += parseFloat(seatWiseFare);
        }else{
          totSeatFare += parseFloat(busIdFarePerSeat);
        }
        
      } else {
        if (selSeat.length === 6 && index === -1) {
          this.setState({ seaterror: true });
        }
      }

      if (index >= 0) {
        selSeat.splice(index, 1);
        //for acco type yes take fare from api getFare
        //for acco type no take fare from getBusID api response and key is FarePerSeat
        if (accoTypeApplicable == 'YES') {
          totSeatFare -= parseFloat(seatWiseFare);
        }else{
          totSeatFare -= parseFloat(busIdFarePerSeat);
        }
      }

      // console.log("total seat fare",totSeatFare);

      const totalSeat = selSeat.length;

      this.setState({
        selSeat,
        totalSeat,
        totSeatFare,
      });

      //for on select seat autoupdate pax number input box
      if (accoTypeApplicable == 'YES') {
        if (accoType == 1) {
          this.setState({
            selNoOfPax: totalSeat,
          });
        }
      } else {
        this.setState({
          selNoOfPax: totalSeat,
        });
      }

    }

    if (Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[tourBus.TripRouteID]) {
      store.dispatch(updateCheckoutDet([]));
      let showPassenger = that.props.search.showPassenger;
      showPassenger[tourBus.TripRouteID] = false;
      store.dispatch(updateShowpassenger(showPassenger));
    }

  };

  /*   closePopup = (param, e) => {
      e.stopPropagation();
      // this.setState({ showFemalePopup: false })
      let selSeat = this.state.selSeat;
      let seatFare = this.state.seatFare;
      let disSeatFare = this.state.disSeatFare;
      let showFemalePopup = false;
      let that = this;
      let val = this.state.selseatVal;
      const index = selSeat.indexOf(val.SeatLabel);
      const bus = this.props.search.data.filter(function (a) {
        return that.props.seat.RouteScheduleId === a.RouteScheduleId;
      })[0];
  
      if (param === 'cancel') {
        selSeat.splice(index, 1);
        seatFare -= val.Fare;
        //seatFare += val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0;
        //seatFare += val.HasSTax ? parseInt(val.ServiceTax, 10) : 0;
  
        if (bus.DiscountAmt > 0 || bus.DiscountPer) {
          let temp = 0;
          temp += val.baseFare;
          disSeatFare -= temp;
        }
      }
      if (param === 'confirm') {
        showFemalePopup = false;
      }
      const totalSeat = selSeat.length;
      this.setState({
        selSeat,
        seatFare,
        disSeatFare,
        totalSeat,
        showFemalePopup,
      });
  
      setTimeout(() => {
        this.setState({ showPoint: 'pick' });
        if (this.pickupDropdownRef.current) {
          this.pickupDropdownRef.current.focus();
        }
      }, 100);
    } */

  showaertdialogue = () => {

    setTimeout(() => {
      this.setState({ alerterror: "" });
    }, 10000);

    return (
      <div
        className="blacklayer"
        onClick={() => {
          this.setState({ alerterror: "" });
        }}
      >
        <div className="popupbox">
          {/*  <div className="circle pixedpos logo-box">
            {renderImg('GsbLogoBold')}
          </div> */}
          <div className="alertmsg">{this.state.alerterror}</div>
          <button
            className="alertbuttonok crsrpointer"
            onClick={() => {
              this.setState({ alerterror: "" });
            }}
          >
            OK{" "}
          </button>
        </div>
      </div>
    );
  };

  loaderShow = () => {
    if (this.state.showLoader) {
      return (
        <div className="show-load">
          <div className="loading">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  render() {

    let that = this;
    // console.log("orderData", this.state.orderData);
    // console.log(this.props.search.showPassenger);
    const returnChartSeatRestrictionFlag = this.state.returnChartSeatRestrictionFlag;
    const totalOnwardSeats = this.state.totalOnwardSeats;
    const remainingSeats = totalOnwardSeats - this.state.selSeat.length;

    const accoTypeApplicable = this.props.seat.AccoTypeApplicable;

    // console.log("-----------------------------------------");
    // console.log("busIdFarePerSeat",this.state.busIdFarePerSeat);
    // console.log("seatWiseFare",this.state.seatWiseFare);
    // console.log("seatWiseSrFare",this.state.seatWiseSrFare);
    // console.log("totSeatFare",this.state.totSeatFare);


    if (this.state.stchrt.lower) {
      return (
        <div className="seatchart">
          {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
          <div className="chartheading flex-vc">
            <div className="seathead">
              {
                <span className="flex-vc mspacerite">
                  <span className="circle ceruleanbg whiteclr lspacerite">
                    2
                  </span>
                  Select Seat
                  {this.state.selSeat.length > 0 &&
                    <span className="greentickmark"></span>
                  }
                </span>
              }
            </div>
            <div className="pickdrophead">
              <span className="flex-vc">
                <span
                  className={`circle lspacerite ceruleanbg whiteclr`}
                >
                  1
                </span>
                Select Accommodation, PAX, Boarding Point
                {((accoTypeApplicable == "YES" && this.state.selAccoType != "" && this.state.selNoOfPax > 0 && this.state.selPick !== "") || (accoTypeApplicable == "NO" && this.state.selNoOfPax > 0 && this.state.selPick !== "")) &&
                  <span className="greentickmark"></span>
                }
              </span>
            </div>
          </div>
          <div className="seat-wrap" ref={this.dropdownRef}>
            <div className="seats">
              {this.showLowerSt()}
              {this.state.stchrt.upper &&
                Object.keys(this.state.stchrt.upper).length > 0
                ? this.showUpperSt()
                : ""}
            </div>
            {this.showPick()}
          </div>
          {this.showLegend()}
          {this.showPassengerDetails(this.props.seat.TripRouteID)}
          {this.loaderShow()}
        </div>
      );
    } /*else if (this.props.search.seatChartErrorMsg[this.props.seat.RouteScheduleId] === 'No more Bookings Can be performed on this Trip,Bus is already locked') {
      return (
        <div className="seatchart--err">
          <div>{renderImg('SeatErrorIcon')}</div>
          <div>The journey has started hence online booking is unavailable. Try another journey option.</div>
        </div>
      );
    }*/ else if (this.props.search.seatChartErrorMsg[this.props.seat.TripRouteID]) {
      return (
        <div className="seatchart--err">
          <div>{renderImg('SeatErrorIcon')}</div>
          <div>{this.props.search.seatChartErrorMsg[this.props.seat.TripRouteID]}</div>
        </div>
      );
    } else {
      return (
        <div className="loading">
          {/* Loading... */}
          <span></span>
          <span></span>
          <span></span>
        </div>
      );
    }
  }

  updateOrderData = (state) => {
    let orderData = state.orderData
    this.setState({ orderData })
  }

  updateGrandTotal = (totSeatFare) => {
    // console.log(totSeatFare);
    this.setState({ totSeatFare });
  }

  showPassengerDetails = (id) => {
    if (Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[id]) {
      return (
        <Passenger
          orderData={this.state.orderData}
          updateOrderData={this.updateOrderData}
          updateGrandTotal={this.updateGrandTotal}
        />
      )
    }
    else if (this.props.search.showPassenger[id]) {
      return (
        <div className="loading">
          {/* Loading... */}
          <span></span>
          <span></span>
          <span></span>
        </div>
      );
    }
    else {
      return null;
    }
  }

  generateSeatStyle = (ell) => {
    //  console.log(ell)
    /* const seatcolor =
      ell.Gender === "F"
        ? color.female
        : this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? color.chekColor : color.green; */
    const seatcolor = color.green;

    return {
      // position: 'relative',
      position: "absolute",
      left: ell.Row * 35 + "px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 33 + "px",
      height: 30 + "px",
      margin: "5px",
      fontSize: "0.625em",
      paddingRight: !Number(ell.BookingStatusId === 5) ? "0" : "5px",
      border: '1px solid',
      borderColor: !Number(ell.BookingStatusId === 5) ? color.alto : seatcolor,
      background: !Number(ell.BookingStatusId === 5)
        ? "#ccc"
        : this.state.selSeat.indexOf(ell.SeatNumber) >= 0
          ? seatcolor : color.white,

      color:
        !Number(ell.BookingStatusId === 5)
          ? "#202020"
          : this.state.selSeat.indexOf(ell.SeatNumber) >= 0 ? "#fff" : "#444",
      opacity: 1,
      userSelect: "none",
      cursor: Number(ell.BookingStatusId === 5) ? "pointer" : "not-allowed",
      fontWeight: '500',
    };
  };
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(withRouter(Seatchart));
